var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolunteerdisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2142 30.464C27.005 30.464 24.4285 27.8876 24.4285 24.6783C24.4285 21.5142 27.005 18.8926 30.2142 18.8926C33.3783 18.8926 35.9999 21.5142 35.9999 24.6783C35.9999 27.8876 33.3783 30.464 30.2142 30.464ZM34.5083 31.9556C37.7628 32.0912 40.3392 34.7581 40.3392 38.0126V39.8658C40.3392 41.0862 39.3448 42.0354 38.1696 42.0354H22.2589C21.0385 42.0354 20.0892 41.0862 20.0892 39.8658V38.0126C20.0892 34.7581 22.6205 32.0912 25.8749 31.9556L28.0446 40.589L29.491 34.4417L28.0446 31.9104H32.3839L30.9374 34.4417L32.3839 40.589L34.5083 31.9556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerdisabled);
export default __webpack_public_path__ + "static/media/volunteerdisabled.8557933d0e8e1656a82c1a16fb9f2740.svg";
export { ForwardRef as ReactComponent };